import { create } from 'zustand';

/**
 * Estado extra del modal de historial de movimientos (error remoto + política
 * owner-only). Vive aparte de `useInventoryUiStore` porque ese store guarda
 * listas/paginado; acá va el estado de "no se pudo cargar" y el gate de dueño.
 */
type InventoryHistoryUiExtras = {
  /** Mensaje de error del último fetch remoto; null = sin error. */
  historyError: string | null;
  /**
   * true cuando el usuario actual no es owner de la organización (#868):
   * el historial completo del equipo es owner-only y el modal lo comunica
   * en vez de mostrar una lista vacía.
   */
  historyOwnerOnly: boolean;
  /** Reintento del último load; lo registra el flow hook. */
  retryHistoryLoad: (() => void) | null;
  setHistoryError: (message: string | null) => void;
  setHistoryOwnerOnly: (v: boolean) => void;
  setRetryHistoryLoad: (fn: (() => void) | null) => void;
  resetHistoryUiExtras: () => void;
};

const initialExtras = () => ({
  historyError: null as string | null,
  historyOwnerOnly: false,
  retryHistoryLoad: null as (() => void) | null,
});

export const useInventoryHistoryUiState = create<InventoryHistoryUiExtras>((set) => ({
  ...initialExtras(),
  setHistoryError: (message) => set({ historyError: message }),
  setHistoryOwnerOnly: (v) => set({ historyOwnerOnly: v }),
  setRetryHistoryLoad: (fn) => set({ retryHistoryLoad: fn }),
  resetHistoryUiExtras: () => set(initialExtras()),
}));
